import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { removeFromCart } from '../actions'
import CartPage from '../components/common/headers/common/cart-header'
import { shopBagDefault } from '../components/common/MangoIcons'

const CartContainer = ({ cartList, total, symbol, cartCount, removeFromCart, clsName }) => (
    <li className={`onhover-div mobile-cart ${clsName}`}> { !!cartCount ? <div className="cart-qty-cls">{cartCount}</div> : ''}
        <Link to={`${process.env.PUBLIC_URL}/cart`} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}><img src={shopBagDefault} alt="" />
            <i style={{ backgroundImage: "url(" + shopBagDefault + ")", width: 30, height: 30 }}></i> shopping bag</Link>
        {/* <img src={shopBagDefault} /><span>Shopping Bag</span> */}
        {/* <ul className="show-div shopping-cart">
            {(cartCount > 0) ?
                <div>
                    <li>
                        <div className="cart-contain-header btn btn-solid shopping_bag">
                            Shopping Bag ({cartCount})
                    </div>
                    </li>
                    <li>
                        <div className="cart-contain-divider"></div>
                    </li>
                </div>
                : null
            }
            {cartList && cartList.map((item, index) => (
                <CartPage key={index} item={item} total={total} symbol={symbol} cartList={cartList} itemNumber={index} />
            ))}
            {(cartCount > 0) ?
                <div>
                    <li>
                        <div className="cart-contain-divider"></div>
                    </li>
                    <li>
                        <div className="cart-contain-total">
                            <div className="left-total"><h5>Total:</h5></div>
                            <div className="right-total"><h5>Rs. {total}</h5></div>
                        </div>
                    </li>
                    <li>
                        <div className="buttons cart-contain-buttons">
                            <div className="left-button">
                                <Link to={`${process.env.PUBLIC_URL}/cart`} className="btn btn-solid button-padding">view cart</Link>
                            </div>
                            <div className="right-button">
                                <Link to={`${process.env.PUBLIC_URL}/checkout`} className="btn btn-solid button-padding">checkout</Link>
                            </div>
                        </div>
                    </li>
                </div>
                :
                <li><h5>Your bag is currently empty.</h5></li>}
        </ul> */}

    </li>
)


function mapStateToProps(state) {
    return {
        cartList: state.cart.cartItems,
        cartCount: state.cart.cartItemsCount,
        total: state.cart.cartTotal,
        symbol: state.data.symbol,
    }
}

export default connect(mapStateToProps, { removeFromCart })(withRouter(CartContainer));
